import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ComentariosClientes from "./cometarios";
import "./index.scss";

export default function SecaoOpiniaoClientes() {
  return (
    <Container
      className="secao-site secao-opiniao-clientes"
      component="section">
      <Grid
        container
        spacing={2}
        sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item size={12} sx={{ p: 1 }}>
          <Typography
            color="primary"
            sx={{
              fontWeight: "bold",
              pt: { xs: 0, md: 5 },
              display: "flex",
              justifyContent: "center",
              fontSize: { xs: "1.8rem", sm: "3rem" },
              textAlign: "center",
            }}>
            O que os nossos clientes dizem sobre nós
          </Typography>
          <Typography
            sx={{
              pt: 4,
              fontSize: "24px",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}>
            Dá uma olhada no que nossos clientes dizem sobre nós!
          </Typography>
        </Grid>
      </Grid>

      <Grid container className="cards-comentarios">
        <ComentariosClientes
          breakpoint={{
            600: {
              slidesPerView: 1,
            },
            1000: {
              slidesPerView: 3,
            },
          }}
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet",
          }} />
      </Grid>
    </Container>
  );
}
